import { SceneWrapper } from '~/components';
import { FormikProps, isEmpty, useFormikContext } from '~/modules';
import { CreditSimulationValueFormValues } from './schema';
import { ButtonComponent, Input } from './styles';
const CreditSimulationValue = () => {
  const {
    values,
    errors,
    setFieldValue,
    submitForm,
    isValid,
  }: FormikProps<CreditSimulationValueFormValues> = useFormikContext();

  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="btn-simulation-value"
          onPress={submitForm}
          disabled={!isValid || isEmpty(values.creditSimulationValue)}
        >
          SIMULAR
        </ButtonComponent>
      }
    >
      <Input
        name="creditSimulationValue"
        id="creditSimulationValue"
        value={values.creditSimulationValue}
        onChange={({ target }) =>
          setFieldValue('creditSimulationValue', target.value)
        }
        label="Qual o valor desejado?"
        maskType="currency"
        errors={errors?.creditSimulationValue}
      />
    </SceneWrapper>
  );
};

export default CreditSimulationValue;
